import toArray from 'lodash/toArray';
import get from 'lodash/get';
import forEach from 'lodash/forEach';

import { caseLogicMsg } from '../validationMessages';

function validateTriggeringActions(caseConf, nodeInfo, validationOptions) {
  if (validationOptions.isEffectChain) {
    return { errors: [], warnings: [] };
  }

  const errors = [];
  const warnings = [];
  const nodeMap = get(caseConf, 'caseLogicDescription.nodes');
  const checkNodes = nodeInfo.checkNodes.filter(node => node.name === 'Check');
  const effectChainNodes = nodeInfo.effectChainNodes.filter(node => node.name === 'EffectChain');

  // Medication nodes with Was triggering action must have a matching action
  // (medication action w/the same med)
  const medCheckList = getTriggeringMedCheckList(checkNodes);
  medCheckList.forEach(medCheckObj => {
    const hasMatching = hasMatchingAction(medCheckObj.node, medCheckObj.medicationId, nodeMap).hasMatching;
    if (!hasMatching) {
      errors.push(caseLogicMsg(
        'Check must follow a matching medication action when triggering action is turned on',
        medCheckObj.node.id,
        { errorId: 'matchingAction', checkKey: medCheckObj.checkKey }
      ));
   }
  });

  // Effect chains with medication nodes with Was triggering action should have
  // a matching action, but it's only a warning if they don't
  for (const ecNode of effectChainNodes) {
    const nodeMap = get(ecNode.data, 'effectChain.nodes');
    const ecNodes = toArray(nodeMap);
    const medCheckList = getTriggeringMedCheckList(ecNodes);
    let hasMatching = false;
    for (const medCheckObj of medCheckList) {
      if (hasMatchingAction(ecNode, medCheckObj.medicationId, nodeMap).hasMatching) {
        hasMatching = true;
        break;
      }
    }
    if (medCheckList.length && !hasMatching) {
      warnings.push(caseLogicMsg(
        'Check should follow a matching medication action when triggering action is turned on',
        ecNode.id,
        { errorId: 'matchingAction' }
      ));
    }
  }

  return {
    errors,
    warnings
  };
}

const TRIGGERING_CHECKS = [
  'MEDICATION_ADMINISTERED',
  'INFUSION_MEDICATION_SETUP',
  'INFUSION_FLUID_SETUP'
]

function getTriggeringMedCheckList(nodes) {
  const list = [];
  for (const node of nodes) {
    forEach(node.data, (check, checkKey) => {
      if (TRIGGERING_CHECKS.includes(check.type) && check.target === 'TRIGGERING') {
        list.push({
          medicationId: check.id,
          checkKey,
          node
        });
      }
    });
  }
  return list;
}

function hasMatchingAction(node, medicationId, nodeMap, cumul = { path: [], hasMatching: false }) {
  const inputConnections = get(node, 'inputs.inputs.connections', []);
  if (inputConnections.length === 0) {
    const isAction = node.name === 'Action';
    const isMatchingMed = isAction && get(node, 'data.action.id') === medicationId;
    return {
      hasMatching: cumul.hasMatching || !!(isAction && isMatchingMed),
      path: cumul.path.concat(node.id)
    };
  }

  let hasMatching = cumul.hasMatching;
  let path = cumul.path;
  inputConnections.forEach(connection => {
    const inputNode = nodeMap[connection.node];
    // Prevent case logic loops from only traversing nodes that haven't been seen yet
    if (inputNode && !cumul.path.includes(inputNode.id)) {
      const result = hasMatchingAction(inputNode, medicationId, nodeMap, {
        hasMatching: cumul.hasMatching,
        path: cumul.path.concat(node.id)
      });
      hasMatching = hasMatching || result.hasMatching;
      path = path.concat(result.path);
    }
  });

  return {
    hasMatching,
    path
  };
}

export default validateTriggeringActions;